import { Button, notification, Popconfirm } from 'antd'
import { FC } from 'react'
import connect from '../../../../../helpers/api/connect'
import { useUpdateFormMutation } from '../../../../../store/api/forms-api'
import { useCreateTaskMutation } from '../../../../../store/api/tasks-api'
import { FailureReason } from '../../../../../types/api/form'
import { FormReorderTaskDetails } from '../../../../../types/api/task'
import { FormsTableRow } from '../../types/forms-table-row'

interface DefectCheckboxProps {
    row: FormsTableRow
    onDefectRegistered: () => void
}

export const DefectCheckbox: FC<DefectCheckboxProps> = ({ row, onDefectRegistered }) => {
    const [updateForm, updateState] = useUpdateFormMutation()
    const [createTask, createTaskState] = useCreateTaskMutation()
    const buttonLoading = updateState.isLoading || createTaskState.isLoading
    const formHasDefect = row.failureReason === FailureReason.ManufacturingDefect

    const onConfirm = async () => {
        const result = await updateForm({
            docId: row.documentId,
            body: {
                data: {
                    dateOfFailure: new Date().toISOString(),
                    failureReason: FailureReason.ManufacturingDefect,
                    inStock: false,
                },
            },
        })

        if ('data' in result) {
            const details: FormReorderTaskDetails = {
                type: 'Перезаказ форм',
                reason: 'defect',
                stampId: row.orderShipment?.stamp?.documentId,
                sourceFormIds: [row.documentId],
                forms: [
                    {
                        documentId: row.documentId,
                        num: row.num,
                        color: row.color,
                        colorName: row.colorName,
                    },
                ],
            }

            await createTask({
                data: {
                    type: 'Перезаказ форм',
                    taskStatus: 'Новая',
                    details,
                    performer: connect(row.orderShipment?.designer),
                    shipment: connect(row.orderShipment),
                    originId: row.orderShipment?.documentId,
                    originType: 'shipment',
                    description: `Брак прихода формы ${row.num} ${row.colorName} ${row.color}. Необходим перезаказ.`,
                },
            })
        }

        onDefectRegistered()

        notification.success({
            message: 'Брак зафиксирован',
            description:
                'Дизайнеру создана задача перезаказа форм. Вы сможете закрыть этот приход. Новая форма придет в новом заказе.',
        })
    }

    return (
        <Popconfirm
            onConfirm={onConfirm}
            title={'Зафиксировать брак? '}
            description={
                'Дизайнеру будет создана задача перезаказа форм. Вы сможете закрыть этот приход. Новая форма придет в новом заказе.'
            }
        >
            <Button loading={buttonLoading} disabled={formHasDefect}>
                {formHasDefect ? 'Брак зафиксирован' : 'Зафиксировать брак'}
            </Button>
        </Popconfirm>
    )
}
